export const getPoiCoordinates = poi => poi?.coordinates ?? {}

export const getPoiAdditionnalInfo = poi => poi?.additionalInfo

export const getPoiIllustrationUrl = poi => getPoiAdditionnalInfo(poi)?.illustration?.url

export const getPoiPrice = poi => getPoiAdditionnalInfo(poi)?.price

export const getPoiPriceLabel = poi => {
  const price = getPoiPrice(poi)
  return price?.value ? `${price.value} ${price?.currency ?? '€'}` : undefined
}

export const getPoiFuels = poi => getPoiAdditionnalInfo(poi)?.fuels

export const getPoiFuelByFuelId = (poi, fuelId) => getPoiFuels(poi)?.find(({ id }) => id === fuelId)

export const getReservationTemplatizeUrl = poi => getPoiAdditionnalInfo(poi)?.reservationTemplatizedUrl

export const getPoiRubric = poi => poi?.rubric

export const getPoiRubricId = poi => getPoiRubric(poi)?.id

export const getPoiRubricSegment = poi => getPoiRubric(poi)?.segment

export const getPoiRubricParent = poi => getPoiRubric(poi)?.parent

export const getPoiCurrentTabId = poi => poi?.currentTabId

export const getPoiFirstTabId = poi => poi?.tabs?.[0]?.appId

export const getPoiApplicationId = poi =>
  getPoiCurrentTabId(poi) || getPoiAdditionnalInfo(poi)?.appId || getPoiFirstTabId(poi)

export const getPoiContextualUrl = poi => poi?.contextualPoiUrl

export const getPoiAverageNote = poi => poi?.reviews?.averageNote

export const getPoiMaxNote = poi => poi?.reviews?.maxNote

export const getPoiNumberOfReviews = poi => poi?.reviews?.numberOfReviews
